import { skipToken } from '@reduxjs/toolkit/query'
import { useUnfurlFileQuery } from '../app/appApiQueries'
import { App } from '../app/root'
import { useEffect, useMemo } from 'react'
import { useSelectAuth, useSetDialog } from './'
import { FileMS } from '../app/file'

export const useUnfurledFile = (app: App, fileUrl: string | undefined) => {
  const auth = useSelectAuth(app)
  const skip = !(fileUrl && auth?.authStatus === 1)
  const trigger = useSetDialog(app, fileUrl)
  const { data: file } = useUnfurlFileQuery(
    fileUrl
      ? {
          drive: app,
          url: fileUrl,
        }
      : skipToken, // Use skipToken to skip the query entirely
    {
      skip,
    }
  )

  const fileDriveId = useMemo(() => {
    return app === 'Microsoft' ? (file as FileMS)?.driveId : undefined
  }, [app, file])

  useEffect(() => {
    if (file?.id) {
      if (app === 'Microsoft') {
        const msFile = file as FileMS
        trigger({
          drive: app,
          fileId: file.id,
          fileDriveId: msFile.driveId,
        })
      } else {
        trigger({
          drive: app,
          fileId: file.id,
        })
      }
    }
  }, [app, file, file?.id, fileDriveId, trigger])
}
